import React, { useState } from "react";
import "./PlaceOrderComponent.css";
import Black_Btn from "../../Common-Component/Common_Btn/Black_Btn/Black_Btn";
import OrderSuccesFullModal from "../../Common-Component/Common_Modal/OrderSuccesFullModal/OrderSuccesFullModal";
import { getAllPaymentMethod } from "../../../features/master/masterSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import useRazorpay from "react-razorpay";
import { createOrder } from "../../../features/order/orderSlice";
import { useNavigate } from "react-router-dom";
const PlaceOrderComponent = ({
  pincodeData,
  data,
  CouponData,
  orderData,
  billingAddressId,
  shippingAddressId,
  setPaymenyMethodId,
  paymenyMethodId,
  cart,
}) => {
  // const data = [
  //   {
  //     id: 1,
  //     label: "Net Banking",
  //     img: "/assets/Images/Cart/Payment/img1.png",
  //   },
  //   {
  //     id: 2,
  //     label: "Wallets",
  //     img: "/assets/Images/Cart/Payment/img2.png",
  //   },
  //   // {
  //   //   id: 3,
  //   //   label: "Card",
  //   //   img: "/assets/Images/Cart/Payment/img3.png",
  //   // },
  //   // {
  //   //   id: 4,
  //   //   label: "UPI",
  //   //   img: "/assets/Images/Cart/Payment/img4.png",
  //   // },
  // ];

  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState(false);
  const [razorid, setRazorId] = useState();
  const [Razorpay] = useRazorpay();
  const payment = useSelector((state) => state.master.payment_method);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllPaymentMethod());
  }, [dispatch]);

  const navigate = useNavigate();
  const handleRazorpay = async (price) => {
    if (pincodeData === "") {
      setError("Pincode Required");
      return;
    }

    const amountInPaise = price * 100;
    const options = {
      key: "rzp_test_I05KCFb1v5JJRc",
      amount: amountInPaise,
      currency: "INR",
      name: "PrintOut",
      description: "Test Transaction",
      image:
        "http://localhost:3000/static/media/hippicart-logo.427718645d3015dbf003.png",

      handler: async (res) => {
        await setRazorId(res.razorpay_payment_id);
        finalFunction(res.razorpay_payment_id);
      },
      prefill: {
        name: "Piyush Garg",
        email: "youremail@example.com",
        contact: "9999999999",
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#052c65",
      },
    };

    const rzpay = new Razorpay(options);
    rzpay.open();
  };

  const finalFunction = async (razorpay) => {

    console.log('llllllllllll');
    
    // if (pincodeData === "") {
    //   setError("Pincode Required");
    //   return;
    // }
    const datafinal = {
      pincode: pincodeData,
      billing_address_id: billingAddressId,
      shipping_address_id: shippingAddressId,
      name: data?.name,
      email: data?.email,
      contact_no: data?.contact_no,
      total: cart?.data?.total,
      amount_paid: cart?.data?.total,
      password: data?.password,
      industry_id: data?.industry_id?.value,
      department_id: data?.department_id?.value,
      company_size_id: data?.company_size_id?.value,
      // address_type_id:
      //   data.type === "Personal" ? 1 : data.type === "Business" ? 2 : null,
      payment_method_id: paymenyMethodId,
      orderData: orderData,
    };
    if (razorpay) {
      datafinal.razorpay_id = razorpay;
    }
    if (CouponData) {
      datafinal.coupon_id = CouponData?.id;
    }

    const res = await dispatch(createOrder(datafinal));

    if (res.meta?.requestStatus === "fulfilled") {
      setShowModal(true);
      setTimeout(() => {
        navigate("/home");
      }, 2000);
    } else if (res.meta?.requestStatus === "rejected") {
      // if (res.payload?.errors?.email) {
      //     setError("email", {
      //       type: "manual",
      //       message: res.payload?.errors?.email,
      //     });
      //   }
    }
  };

  return (
    <section className="PlaceOrderComponent SelectAddressComponent">
      <p className="heading_text">Payment</p>

      <div className="payment_option_main_div">
        <div className="payment_card_holder">
          <div className="row">
            {error && <span style={{ color: "red" }}>{error}</span>}
            {payment?.map((item) => {
              return (
                <div className="col-lg-3 col-md-3 col-sm-3 col-4" key={item.id}>
                  <div
                    className={`payment_card ${
                      paymenyMethodId === item.id ? "active" : ""
                    }`}
                    onClick={() => setPaymenyMethodId(item.id)}
                  >
                    {/* <div className="img_holder">
                      <img src={item.img} className="img" alt={item.label} />
                    </div> */}

                    <p className="payment_text">{item?.name}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* <div className="btn_holder" onClick={() => handleRazorpay()}>
          <Black_Btn btnText={"Place Order"} />
        </div>

        <div className="btn_holder" onClick={() => finalFunction()}>
          <Black_Btn btnText={"Place Order"} />
        </div> */}

        <div className="btn_holder">
          <Black_Btn
            btnText="Place Order"
            onClick={() => {
              const totalAmount = Number(
                Math.round(orderData?.order_summary?.total || 0)
              );

              if (Number(paymenyMethodId) === 1) {
                finalFunction();
              } else {
                handleRazorpay(totalAmount);
              }
            }}
          />
        </div>
      </div>

      <OrderSuccesFullModal
        show={showModal}
        successText="Order Placed Successfully!"
        onHide={() => setShowModal(false)}
      />
    </section>
  );
};

export default PlaceOrderComponent;
